
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SurveyQuoteForm from './SurveyQuoteForm';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SurveyQuoteForm />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
